// extracted by mini-css-extract-plugin
export default {"Stats":"PostStats_Stats__zNQCi","Stats__Stat":"PostStats_Stats__Stat__DP9N3"};